import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { PaymentBadges } from './PaymentBadges';
import { GuaranteeSeal } from './GuaranteeSeal';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/833f2e5e-073b-483f-90b1-6f2c27322c0e.jpg';
type PriceBlockProps = {
  /** Optional short eyebrow shown above the price */
  id?: string;
};

/**
 * Reusable pricing / offer block: product mockup, strikethrough regular
 * price, flash launch price, CTA, currency note, payment badges and the
 * 7-day guarantee seal. Reused several times down the page.
 */
export function PriceBlock({
  id
}: PriceBlockProps) {
  return <div id={id} className="mx-auto max-w-3xl" data-id="element-136" data-mp="1p5ic9r1q0plw">
      <div className="overflow-hidden rounded-3xl border border-cream-deep bg-white shadow-xl shadow-ink/5" data-id="element-137" data-mp="1p4qh2hc1ctw5">
        <div className="grid gap-6 p-6 sm:p-8 md:grid-cols-2 md:items-center md:gap-8 md:p-10" data-id="element-138" data-mp="11ecwtczozzc4">
          <motion.img initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          amount: 0.4
        }} transition={{
          duration: 0.5
        }} src={PRODUCT_IMG} alt="Vista del ebook de recetas y el curso en el celular del Método Esencia Viva" className="mx-auto w-full max-w-xs rounded-2xl md:max-w-none" data-id="element-139" data-mp="wgbcypufzvzl" />

          <div className="text-center md:text-left" data-id="element-140" data-mp="26qgwqwwgo64g">
            <span className="inline-block rounded-full bg-cream px-3 py-1 text-xs font-extrabold uppercase tracking-wide text-sage-deep" data-id="element-141" data-mp="191xcjghvgfi7">
              50% OFF
            </span>

            <p className="mt-4 text-lg text-ink/60" data-id="element-142" data-mp="1iytqi1qjhtu5">
              Precio Regular{' '}
              <span className="font-bold text-ink/70 line-through decoration-red-400 decoration-2" data-id="element-143" data-mp="1n0evz20qv5ub">
                $29.990 ARS
              </span>
            </p>

            <p className="mt-2 font-serif text-sm font-bold uppercase tracking-wide text-ink/70" data-id="element-144" data-mp="2ugb8tc8yhqnn">
              50% de descuento
            </p>

            <p className="mt-1 font-serif text-5xl font-bold leading-none text-sage-deep sm:text-6xl" data-id="element-145" data-mp="zaam5padgnmy">
              $14.990 ARS
            </p>
            <p className="mt-1 text-sm font-bold uppercase tracking-wide text-ink/60" data-id="element-146" data-mp="ubpgvbg9jdrn">
              Pesos argentinos · Único pago
            </p>

            <div className="mt-6" data-id="element-147" data-mp="13c5nuuw7t319">
              <CtaButton data-id="element-148" data-mp="13d6vepe0v7e8">Regístrate ahora dando clic aquí</CtaButton>
            </div>

            <p className="mt-3 text-xs leading-relaxed text-ink/50" data-id="element-149" data-mp="fnw3lxengnc8">
              El cobro se realiza en pesos argentinos (ARS) mediante una pasarela de pago segura.
            </p>
          </div>
        </div>

        <div className="flex flex-col items-center gap-5 border-t border-cream-deep bg-cream/60 px-6 py-6 sm:flex-row sm:justify-between sm:px-10" data-id="element-150" data-mp="pegxx8naj5pc">
          <PaymentBadges data-id="element-151" data-mp="3t1prn5x4v4cd" />
          <GuaranteeSeal data-id="element-152" data-mp="3t0xtbnc5isie" />
        </div>
      </div>
    </div>;
}